import { defu } from 'defu'
const foldedMatcher = /* @__PURE__ */ (() => { const $0={payload: true,payload: true}; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1);let s=p.split("/");if(s.length>1&&s[s.length-1]===""){s.pop();p=p.slice(0,-1)}let l=s.length;if(l>1){if(s[1]==="1882"){r.push({data:$0,params:{"_":p.slice(6),}});}else if(s[1]==="gava"){r.push({data:$0,params:{"_":p.slice(6),}});}else if(s[1]==="manadsgivare"){r.push({data:$0,params:{"_":p.slice(14),}});}else if(s[1]==="arsmedlem"){r.push({data:$0,params:{"_":p.slice(11),}});}else if(s[1]==="ge-medlemskap"){r.push({data:$0,params:{"_":p.slice(15),}});}else if(s[1]==="foretagsgava"){r.push({data:$0,params:{"_":p.slice(14),}});}else if(s[1]==="gavobevis"){r.push({data:$0,params:{"_":p.slice(11),}});}else if(s[1]==="minnesgava"){r.push({data:$0,params:{"_":p.slice(12),}});}else if(s[1]==="fornya"){r.push({data:$0,params:{"_":p.slice(8),}});}}return r.reverse();}})()
const decodeRoutePath = function decodeRoutePath(path) {
	if (!path.includes("%")) return path;
	const queryIndex = path.indexOf("?");
	const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
	try {
		return queryIndex === -1 ? decodeURI(pathname) : decodeURI(pathname) + path.slice(queryIndex);
	} catch {
		return path;
	}
}
const resolveRoutePathDotSegments = function resolveRoutePathDotSegments(path) {
	const queryIndex = path.indexOf("?");
	const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
	if (!/(?:^|\/)(?:\.|%2e)/i.test(pathname)) return path;
	const input = pathname.split("/");
	const output = [];
	const root = pathname.startsWith("/") ? 1 : 0;
	for (const [i, segment] of input.entries()) {
		const dots = /^(?:\.|%2e)(\.|%2e)?$/i.exec(segment);
		if (!dots) {
			output.push(segment);
			continue;
		}
		if (dots[1] && output.length > root) output.pop();
		if (i === input.length - 1) output.push("");
	}
	const resolved = output.join("/");
	return queryIndex === -1 ? resolved : resolved + path.slice(queryIndex);
}
const foldRouteCase = function foldRouteCase(path) {
	return path.replace(/[A-Z]+|[^\0-\x7F]/g, (char) => {
		if (char.charCodeAt(0) < 128) return char.toLowerCase();
		const upper = char.toUpperCase();
		if (upper.length !== 1 || upper.charCodeAt(0) < 128) return char;
		const lower = upper.toLowerCase();
		return lower.length === 1 && lower.toUpperCase() === upper ? lower : upper;
	});
}
const matchAllRouteRules = function matchAllRouteRules(match, path) {
	const matches = match(path);
	if (typeof path !== "string") return matches;
	const split = path.replace(/^[^?]*/, (pathname) => pathname.replace(/%2f/gi, "/"));
	if (split === path) return matches;
	for (const rules of match(split)) if (!matches.includes(rules)) matches.push(rules);
	return matches;
}
const normalizePath = (path, fold) => {
  if (typeof path !== 'string') { return path }
  const decoded = decodeRoutePath(resolveRoutePathDotSegments(path))
  return fold ? foldRouteCase(decoded) : decoded
}
export default path => defu({}, ...matchAllRouteRules(path => foldedMatcher('', normalizePath(path, true)).map(r => r.data), path).reverse())